import React from "react";
import TablaSettings from "./components/TablaSettings";

const BcoChilePage = () => {
  return (
    <div className="container-fluid">
      <div className="page-header d-print-none">
        <div className="container-xl">
          <div className="row g-2 align-items-center">
            <div className="col">
              <div className="page-pretitle">Carga Vales Banco Chile</div>
              <h2 className="page-title">Vales Banco Chile</h2>
            </div>
          </div>
        </div>
      </div>
      <div className="page-body">
        <div className="container-xl">
          <div className="row row-deck row-cards">
            <div className="col-sm-12 col-lg-12">
              <div className="card">
                <div className="card-body">
                  <TablaSettings />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BcoChilePage;
